import ConfirmBox from "../../../../components/boxes/ConfirmBox";
import XsCont from "../../../../components/containers/Xs";
import { API_URL } from "../../../../consts/ApiUrl";
import { validationMessage } from "../../../../consts/ValidationMessage";
import { getCognitoUser } from "../../../../utils/cognitoUtils";
import { Typography, Box, TextField, Button } from "@mui/material";
import { CognitoUser, CognitoUserSession } from "amazon-cognito-identity-js";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const ConfirmEmailStep: React.FC = () => {
  const navigate = useNavigate();
  const [confirmationCode, setConfirmationCode] = useState<string>("");
  const [error, setError] = useState<string>("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmationCode(e.target.value);
    setError("");
  };

  const handleButtonClick: () => Promise<void> = async (): Promise<void> => {
    if (!confirmationCode.trim()) {
      setError(`認証コード${validationMessage.REQUIRED}`);
      return;
    }
    try {
      const loginId: string = sessionStorage.getItem("loginId") || "";
      const newEmail: string = sessionStorage.getItem("newEmail") || "";
      const user: CognitoUser = getCognitoUser(loginId);

      user.getSession(
        async (
          err: Error | null,
          session: CognitoUserSession
        ): Promise<void> => {
          if (err || !session.isValid()) {
            console.error("セッションが無効です: ", err);
            navigate("/signin");
            return;
          }
          const idToken: string = session.getIdToken().getJwtToken();

          user.verifyAttribute("email", confirmationCode, {
            onSuccess: async (): Promise<void> => {
              try {
                const response: Response = await fetch(API_URL.USER, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authentication: idToken,
                  },
                  body: JSON.stringify({
                    operation: "update",
                    email: newEmail,
                  }),
                });
                if (!response.ok) {
                  if (response.status === 401) {
                    navigate("/signin");
                  } else {
                    navigate("/error");
                  }
                  return;
                }
                sessionStorage.removeItem("newEmail");
                navigate("/update/comp");
              } catch (apiError) {
                console.error("APIエラー: ", apiError);
                navigate("/error");
              }
            },
            onFailure: (verifyError): void => {
              console.error("認証コードの検証に失敗しました: ", verifyError);
              setError("認証に失敗しました。");
            },
          });
        }
      );
    } catch (e) {
      console.error("処理中のエラー: ", e);
      navigate("/error");
    }
  };

  const handleResend: () => void = (): void => {
    try {
      const loginId: string = sessionStorage.getItem("loginId") || "";
      const user: CognitoUser = getCognitoUser(loginId);

      user.getAttributeVerificationCode("email", {
        onSuccess: (): void => {
          alert("認証コードを再送信しました。メールをご確認ください。");
        },
        onFailure: (): void => {
          setError("認証コードの再送信に失敗しました。");
        },
      });
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      navigate("/error");
    }
  };

  return (
    <XsCont>
      <ConfirmBox>
        <Box mt={2} mb={3} textAlign="center">
          <Typography variant="h5" gutterBottom>
            認証コード入力
          </Typography>
        </Box>
        <Box mt={2} mb={2} textAlign="center">
          <Typography variant="body2">
            入力されたメールアドレスにメールを送信しました。
            <br />
            メールをご確認の上認証コードを入力してください。
          </Typography>
        </Box>
        <TextField
          label="認証コード"
          variant="outlined"
          required
          fullWidth
          sx={{ maxWidth: "320px", marginTop: "5px" }}
          value={confirmationCode}
          onChange={handleChange}
          error={!!error}
          helperText={error}
        />
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleButtonClick}
          sx={{ maxWidth: "320px", marginTop: "15px" }}
        >
          認証
        </Button>
        <Button
          variant="outlined"
          color="primary"
          fullWidth
          onClick={handleResend}
          sx={{ maxWidth: "320px", marginTop: "5px", marginBottom: "20px" }}
        >
          認証コードを再度送信
        </Button>
      </ConfirmBox>
    </XsCont>
  );
};

export default ConfirmEmailStep;
